import React, { Component } from 'react';
import Flatpickr from 'react-flatpickr'
var ReactSuperSelect = require('react-super-select')

class BurialDeskTransferNumbers extends Component {
	constructor(props) {
		super(props);
		this.state = {
			editingHours: false,
			loading: false
		};
	}

	cancel = () => {
		this.setState({ editingHours: false, loading: false, start: false, end: false })
	}

	editHours = (day) => e => {
		this.setState({ editingHours: true, loading: false, dayName: day.DayOfWeek, day: day.RecNum, error: '', start: day.StartDateTime, end: day.EndDateTime, primary: day.PrimaryTransferNumber, secondary: day.SecondaryTransferNumber })
	}
	editValue = (type) => (e) => {
		var newState = JSON.parse(JSON.stringify(this.state))

		if (e.target.value.length < 1) {
			newState[type] = ''
			newState.error = 'Please enter a ' + type + ' transfer number.'
		} else {
			newState[type] = e.target.value.replace(/[^0-9]/gm, '')
			newState.error = ''
		}
		this.setState(newState);
	}
	confirmHours = () => {
		for (var day of this.props.data.BurialDeskTransferNumbers) {
			if (this.state.dayName == day.DayOfWeek && this.state.day != day.RecNum) {
				if (
					(new Date(this.state.start).getTime() > new Date(day.StartDateTime).getTime() && new Date(this.state.start).getTime() < new Date(day.EndDateTime).getTime())
					||
					(new Date(this.state.end).getTime() > new Date(day.StartDateTime).getTime() && new Date(this.state.end).getTime() < new Date(day.EndDateTime).getTime())
				) {
					this.setState({ error: 'This time period overlaps another' });
					return false
				}
			}
		}
		if (new Date(this.state.start) > new Date(this.state.end)) {
			this.setState({ error: 'End time must not be before Start time.' });
		} else {
			this.setState({ loading: true });
			this.props.ws.send(JSON.stringify({ route: 'editBDTransfers', dayName: this.state.dayName, day: this.state.day, start: this.state.start, end: this.state.end, primary: this.state.primary, secondary: this.state.secondary }))
		}
	}

	checkEnter = (e) => {
		if (e.keyCode === 13) {
			this.confirmHours();
		}
	}

	componentWillReceiveProps(nextProps) {
		if (this.state.loading) {
			this.cancel();
		}
	}

	render() {
		if (this.props.active) {
			var bhList = []
			for (var day of this.props.data.BurialDeskTransferNumbers) {
				bhList.push(
					<div className="dataRow" key={day.RecNum} onClick={this.editHours(day)}>
						<span style={{ flex: '0 0 150px' }} >{day.DayOfWeek}</span>
						<span style={{ flex: '1 0 15%', textAlign: 'center' }}>{new Date(day.StartDateTime).toLocaleTimeString()}</span>
						<span style={{ flex: '1 0 15%', textAlign: 'center' }}>{new Date(day.EndDateTime).toLocaleTimeString()}</span>
						<span style={{ flex: '1 0 15%', textAlign: 'center' }}>{day.PrimaryTransferNumber}</span>
						<span style={{ flex: '1 0 15%', textAlign: 'center' }}>{day.SecondaryTransferNumber}</span>
					</div>
				)
			}


			var editHours = ""
			if (this.state.editingHours) {
				editHours = (
					<div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
						<div className="pop" >
							<div className="viewCloser" onClick={this.cancel}>X</div>
							<div>You Are Editing Transfer Information for {this.state.dayName}</div>
							<br />

							<div style={{ display: 'inline-block' }}>
								<div>Start Time</div>
								<Flatpickr style={{ border: '1px solid #2A6AA9', padding: '15px', width: '130px', margin: '5px' }} options={{ enableSeconds: true, enableTime: true, noCalendar: true, dateFormat: "h:i:S K" }} value={this.state.start} onChange={date => { date[0] ? this.setState({ start: date[0] }) : this.setState({ start: undefined }) }} />
							</div>

							<div style={{ display: 'inline-block' }}>
								<div>End Time</div>
								<Flatpickr style={{ border: '1px solid #2A6AA9', padding: '15px', width: '130px', margin: '5px' }} options={{ enableSeconds: true, enableTime: true, noCalendar: true, dateFormat: "h:i:S K" }} value={this.state.end} onChange={date => { date[0] ? this.setState({ end: date[0] }) : this.setState({ end: undefined }) }} />
							</div>

							<div className="snazzyInputBox">
								<input className="textInput" type="text" required value={this.state.primary} onChange={this.editValue('primary')} ></input>
								<span className="inputBar"></span><label className="textLabel">Primary Number</label>
							</div>

							<div className="snazzyInputBox">
								<input className="textInput" type="text" required value={this.state.secondary} onChange={this.editValue('secondary')} ></input>
								<span className="inputBar"></span><label className="textLabel">Secondary Number</label>
							</div>

							<div className="error" style={{ padding: '15px' }}>{this.state.error}</div>

							{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmHours}>Confirm Hours</div>}
						</div>
					</div>
				)
			}


			return (
				<div width="100%">
					<div className="dataHeaders">
						<span style={{ flex: '0 0 150px' }}>Day</span>
						<span style={{ flex: '1 0 15%' }}>Start Time</span>
						<span style={{ flex: '1 0 15%' }}>End Time</span>
						<span style={{ flex: '1 0 15%' }}>Primary</span>
						<span style={{ flex: '1 0 15%' }}>Secondary</span>
					</div>

					<div style={{ overflow: 'auto', height: 'calc(100% - 85px)' }}>
						{bhList}
					</div>

					{editHours}
				</div>
			);
		} else {
			return (
				<div width="100%">

				</div>
			);
		}
	}
}

const icon = "menuWorkflow"
const roles = ["View", "Add", "Edit", "Delete"]

export { BurialDeskTransferNumbers, roles, icon }
